// @ts-nocheck
import React, { useState } from 'react';
import { format, subDays, subMonths, subYears } from 'date-fns';

interface AdminDateRangeFilterProps {
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
  className?: string;
}

export const AdminDateRangeFilter: React.FC<AdminDateRangeFilterProps> = ({
  onDateRangeChange,
  className = '',
}) => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [preset, setPreset] = useState<string>('');

  const handlePresetChange = (presetValue: string) => {
    setPreset(presetValue);
    let start: Date | null = null;
    let end: Date | null = new Date();

    switch (presetValue) {
      case 'today':
        start = new Date();
        start.setHours(0, 0, 0, 0);
        break;
      case 'yesterday':
        start = subDays(new Date(), 1);
        start.setHours(0, 0, 0, 0);
        end = subDays(new Date(), 1);
        end.setHours(23, 59, 59, 999);
        break;
      case '7d':
        start = subDays(new Date(), 7);
        break;
      case '30d':
        start = subDays(new Date(), 30);
        break;
      case '90d':
        start = subDays(new Date(), 90);
        break;
      case 'thisMonth':
        start = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        break;
      case 'lastMonth':
        start = subMonths(new Date(), 1);
        start.setDate(1);
        end = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        end.setHours(23, 59, 59, 999);
        break;
      case 'thisYear':
        start = new Date(new Date().getFullYear(), 0, 1);
        break;
      case 'lastYear':
        start = subYears(new Date(), 1);
        start.setMonth(0, 1);
        end = new Date(new Date().getFullYear() - 1, 11, 31);
        end.setHours(23, 59, 59, 999);
        break;
      case 'custom':
        setStartDate('');
        setEndDate('');
        return;
      case 'clear':
        setPreset('');
        setStartDate('');
        setEndDate('');
        onDateRangeChange(null, null);
        return;
    }

    if (start) {
      setStartDate(format(start, 'yyyy-MM-dd'));
    }
    if (end) {
      setEndDate(format(end, 'yyyy-MM-dd'));
    }

    onDateRangeChange(start, end);
  };

  const handleCustomDateChange = () => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      onDateRangeChange(start, end);
      setPreset('custom');
    } else {
      onDateRangeChange(null, null);
    }
  };

  return (
    <div className={`flex flex-col sm:flex-row sm:items-center gap-3 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full sm:w-auto">
        <span className="text-sm font-medium text-luna-text-light/70 dark:text-luna-text-dark/70 whitespace-nowrap">
          Date Range:
        </span>
        <select
          value={preset}
          onChange={(e) => handlePresetChange(e.target.value)}
          className="w-full sm:w-auto px-4 py-2.5 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark text-sm min-h-[44px] touch-manipulation"
        >
          <option value="">Select Preset</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="7d">Last 7 Days</option>
          <option value="30d">Last 30 Days</option>
          <option value="90d">Last 90 Days</option>
          <option value="thisMonth">This Month</option>
          <option value="lastMonth">Last Month</option>
          <option value="thisYear">This Year</option>
          <option value="lastYear">Last Year</option>
          <option value="custom">Custom Range</option>
          <option value="clear">Clear</option>
        </select>
      </div>

      {(preset === 'custom' || (!preset && (startDate || endDate))) && (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full sm:w-auto">
          <input
            type="date"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              if (e.target.value && endDate) {
                handleCustomDateChange();
              }
            }}
            className="w-full sm:w-auto px-4 py-2.5 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark text-sm min-h-[44px] touch-manipulation"
          />
          <span className="text-luna-text-light/50 dark:text-luna-text-dark/50 text-center sm:text-left">to</span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              if (startDate && e.target.value) {
                handleCustomDateChange();
              }
            }}
            className="w-full sm:w-auto px-4 py-2.5 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark text-sm min-h-[44px] touch-manipulation"
          />
        </div>
      )}
    </div>
  );
};

